import ActionTypeCliente from "../ActionTypeCliente";

export default class ActualizarClienteAFacturar extends ActionTypeCliente {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = true;
        /* nuevoEstado.flag.sensorDeAccionActualizar = !(estado.flag.sensorDeAccionActualizar); */
        return nuevoEstado;
    }
}
